import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      name: 'SOC 2 Type II',
      icon: 'Shield',
      description: 'Security & Availability'
    },
    {
      name: 'ISO 27001',
      icon: 'Award',
      description: 'Information Security'
    },
    {
      name: 'GDPR Compliant',
      icon: 'Lock',
      description: 'Data Protection'
    },
    {
      name: 'Enterprise Grade',
      icon: 'Building2',
      description: 'Enterprise Security'
    }
  ];

  const securityFeatures = [
    'End-to-end encryption',
    'Role-based access control',
    'Audit trail logging',
    'Data residency options',
    'SSO integration',
    '99.9% uptime SLA'
  ];

  return (
    <div className="bg-muted/30 rounded-xl p-8 mt-16">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-foreground mb-4">
          Enterprise Security & Compliance
        </h3>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          BPMLflows meets the highest security standards required by enterprise organizations worldwide.
        </p>
      </div>
      {/* Trust Badges */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
        {trustBadges?.map((badge, index) => (
          <div key={index} className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon 
                name={badge?.icon} 
                size={32} 
                className="text-primary"
              />
            </div>
            <h4 className="font-semibold text-foreground text-sm mb-1">
              {badge?.name}
            </h4>
            <p className="text-xs text-muted-foreground">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
      {/* Security Features */}
      <div className="grid md:grid-cols-2 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-3">
            <Icon 
              name="CheckCircle2" 
              size={16} 
              className="text-success flex-shrink-0"
            />
            <span className="text-sm text-foreground">
              {feature}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;